import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getTickets = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/tickets${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createTicket = (data, token) => {
  return axios.post(`${baseUrl}/addticket`, data, {
    headers: {
      authorization: token,
    },
  });
};

export const deleteTicket = (id, token) =>
  axios.delete(`${baseUrl}/tickets/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateTicket = (id, data, token) =>
  axios.patch(`${baseUrl}/tickets/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getTicketById = (id, token) =>
  axios.get(`${baseUrl}/ticketdetailbyId?ticketid=${id}`, {
    headers: {
      authorization: token,
    },
  });
export const createNote = (data, token) => {
  return axios.post(`${baseUrl}/ticketnotes`, data, {
    headers: {
      authorization: token,
    },
  });
};
export const createAttachment = (myFile, id, token) => {
  return axios.post(`${baseUrl}/uploadAttachments/${id}`, myFile, {
    headers: {
      authorization: token,
    },
  });
};

export const updateAuditTicket = (data, token, id) =>
  axios.patch(`${baseUrl}/ticketauditupdates/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getUpdateTicketTable = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/ticketUpdates${qs}`, {
    headers: {
      authorization: token,
    },
  });
};
export const getAuditTicketTable = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/ticketAudit${qs}`, {
    headers: {
      authorization: token,
    },
  });
};
export const getAttachmentTicketTable = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/ticketAttachments${qs}`, {
    headers: {
      authorization: token,
    },
  });
};
export const getAttachmentDownload = (id, token) =>
  axios.get(`${baseUrl}/ticketUpdates?ticketid=${id}`, {
    headers: {
      authorization: token,
    },
  });
export const getPdfViewer = (id, token) => {
  let url = `${baseUrl}/downloadfile/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
export const getTicketsByUserId = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getTicketsByUserID${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
